<div class="content-wrapper">
  <div class="content">
    <div class="form-group">
      <label>Fee</label>
      <input-data [type]="typeOfInput.MONEY" name="CHARGE" [(ngModel)]="report.CHARGE"
        [allowZero]="true" [showButton]="false" placeholder="0.00" [allowNegative]="false"
        [maxLength]="50"></input-data>
    </div>

    <div class="form-group" style="margin-bottom: 0;">
      <label>Charge Desc</label>
      <textarea rows="3" class="form-control charge-desc rounded-0 rbv-field" [(ngModel)]="report.CHARGE_DESC"
        placeholder="= $2,500 + $300"></textarea>
    </div>
  </div>
</div>
